import { createSlice } from '@reduxjs/toolkit';
import { createChangeAdvertiseStatus } from './api';
import { initialState } from './api/interface';

const changeAdvertiseStatusSlice = createSlice({
  name: 'changeAdvertiseStatus',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(createChangeAdvertiseStatus.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createChangeAdvertiseStatus.fulfilled, (state, action) => {
      state.data.push(action.payload);
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(createChangeAdvertiseStatus.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });

  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } = changeAdvertiseStatusSlice.actions;
export default changeAdvertiseStatusSlice.reducer;
